/**
 * Constants for message types in conversations (as defined by the API)
 */
export const MESSAGE_TYPE = {
  HUMAN: 'human' as const,
  AI: 'ai' as const,
}

/**
 * Constants for roles in chat messages (as used in our internal store)
 */
export const CHAT_ROLE = {
  USER: 'user' as const,
  ASSISTANT: 'assistant' as const,
  SYSTEM: 'system' as const,
}

/**
 * Mapping between API message types and internal chat roles
 */
export const MESSAGE_TYPE_TO_ROLE = {
  [MESSAGE_TYPE.HUMAN]: CHAT_ROLE.USER,
  [MESSAGE_TYPE.AI]: CHAT_ROLE.ASSISTANT,
}

export const ROLE_TO_MESSAGE_TYPE = {
  [CHAT_ROLE.USER]: MESSAGE_TYPE.HUMAN,
  [CHAT_ROLE.ASSISTANT]: MESSAGE_TYPE.AI,
}
